import React from 'react';
import { Search, Phone, CheckCircle, ArrowRight } from 'lucide-react';
import Container from '../Container';
import Button from '../Button';

const GoogleAdsLanding = () => {
  const benefits = [
    'Guaranteed First Page Rankings',
    'Local SEO Domination',
    'Monthly Performance Reports',
    'No Long-Term Contracts'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <Container>
        <div className="pt-32 pb-20">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full mb-6">
              Limited Time Offer: Free SEO Audit ($500 Value)
            </div>
            
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Dominate Google Rankings in Raleigh
              <span className="text-blue-600"> Within 90 Days</span>
            </h1>

            <p className="text-xl text-gray-600 mb-4">
              Join the 500+ local businesses already crushing their competition with our proven SEO strategies
            </p>

            <a href="tel:9192714871" className="flex items-center justify-center text-2xl text-blue-600 font-bold mb-8 hover:text-blue-700">
              <Phone className="h-6 w-6 mr-2" />
              (919) 271-4871
            </a>

            <Button className="text-lg px-8 py-4 mb-8" withArrow>
              Get Your Free SEO Audit
            </Button>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center justify-center text-gray-700">
                  <CheckCircle className="h-5 w-5 text-blue-600 mr-2" />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md mx-auto">
            <h2 className="text-2xl font-bold text-center mb-6">Get Your Free SEO Audit</h2>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="Business Name"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="text"
                placeholder="Website URL"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="email"
                placeholder="Email Address"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <Button className="w-full text-lg py-4">
                Get Started Now
              </Button>
            </form>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default GoogleAdsLanding;